import Slider from 'react-slick';
import avatar1 from '../assets/images/avatar-6.png';
import avatar2 from '../assets/images/avatar-7.png';
import avatar3 from '../assets/images/avatar-3.png';
import avatar4 from '../assets/images/avatar-8.png';
import avatar5 from '../assets/images/avatar-9.png';
import star from '../assets/images/star.png';

function SampleNextArrow({ style, onClick }) {
	return (
		<button style={{ ...style, display: "block", position: "absolute", top: "50%", right: "0px", padding: "2px" }}
			onClick={onClick} className="text-5xl text-pink-350 hover:opacity-90 transition-all">&gt;</button>
	);
}

function SamplePrevArrow({ style, onClick }) {
	return (
		<button style={{ ...style, display: "block", position: "absolute", top: "50%", left: "0px", padding: "2px" }}
			onClick={onClick} className="text-5xl text-pink-350 hover:opacity-90 transition-all">&lt;</button>
	);
}

export default function ClientsReviews() {
	const rating = (
		<div className="flex flex-row justify-center">
			<img className="flex-none" src={star} alt="star" />
			<img className="flex-none" src={star} alt="star" />
			<img className="flex-none" src={star} alt="star" />
			<img className="flex-none" src={star} alt="star" />
			<img className="flex-none" src={star} alt="star" />
		</div>
	);

	return (
		<>
			<section className="my-24 py-20 text-center bg-gradient-to-r from-gray-300/10 via-gray-300/25 to-pink-350/25 min-w-0 relative overflow-hidden">
				<div className={`${window.location.pathname.includes("/services/") || window.location.pathname.includes("/service/") ? "testimonials-triangle-topLeft-purple" : "testimonials-triangle-topLeft"} absolute align-bottom`}></div>
				<div className="testimonials-triangle-topRight absolute align-top 2xl:testimonials-triangle-topRight-xl"></div>
				<h2 className="my-5 text-center text-3xl font-bold">Our Clients Reviews</h2>
				<div className="mx-auto px-20 lg:px-32 max-lg:px-8 max-md:px-3">
					<Slider
						dots={true}
						slidesToShow={1}
						slidesToScroll={2}
						autoplay={false}
						autoplaySpeed={3000}
						adaptiveHeight={false}
						centerMode={true}
						infinite={true}
						nextArrow={<SampleNextArrow />}
						prevArrow={<SamplePrevArrow />}
					>
						<article>
							<div className="flex flex-row justify-items-center items-baseline min-w-0">
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar1} alt="Avatar Jacob B." />
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar2} alt="Avatar Diana G." />
								<img className="mx-auto flex-none h-18 w-18 md:h-24 md:w-24" src={avatar3} alt="Avatar Mia S." />
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar4} alt="Avatar Natalie R." />
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar5} alt="Avatar Kate J." />
							</div>
							<h3 className="my-5 text-lg font-semibold">Mia S.</h3>
							<p className="my-5">I'm a fitness enthusiast, and I decided to try buying real likes. It genuinely helped increase engagement on my posts, motivating me to push my fitness journey further.</p>
							{rating}
						</article>
						<article className="px-20 lg:px-32 max-lg:px-8 max-md:px-3">
							<div className="flex flex-row justify-items-center items-baseline">
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar2} alt="Avatar Diana G." />
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar3} alt="Avatar Mia S." />
								<img className="mx-auto flex-none h-18 w-18 md:h-24 md:w-24" src={avatar4} alt="Avatar Natalie R." />
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar5} alt="Avatar Kate J." />
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar1} alt="Avatar Jacob B." />
							</div>
							<h3 className="my-5 text-lg font-semibold">Natalie R.</h3>
							<p className="my-5">I'm a foodie, and after buying likes, I noticed more people appreciating my culinary creations. It's been a great confidence booster!</p>
							{rating}
						</article>
						<article className="px-20 lg:px-32 max-lg:px-8 max-md:px-3">
							<div className="flex flex-row justify-items-center items-baseline">
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar3} alt="Avatar Mia S." />
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar4} alt="Avatar Natalie R." />
								<img className="mx-auto flex-none h-18 w-18 md:h-24 md:w-24" src={avatar5} alt="Avatar Kate J." />
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar1} alt="Avatar" />
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar2} alt="Avatar Diana G." />
							</div>
							<h3 className="my-5 text-lg font-semibold">Kate J.</h3>
							<p className="my-5">The Instagram algorithm is not working in our favor at the moment. Looking for alternative solutions I found this service and it made a massive change to my profile! Love it!</p>
							{rating}
						</article>
						<article className="px-20 lg:px-32 max-lg:px-8 max-md:px-3">
							<div className="flex flex-row justify-items-center items-baseline">
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar4} alt="Avatar Natalie R." />
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar5} alt="Avatar Kate J." />
								<img className="mx-auto flex-none h-18 w-18 md:h-24 md:w-24" src={avatar1} alt="Avatar Jacob B." />
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar2} alt="Avatar Diana G." />
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar3} alt="Avatar Mia S." />
							</div>
							<h3 className="my-5 text-lg font-semibold">Jacob B.</h3>
							<p className="my-5">Boosed my credibility and visibility. This is a growth hack.</p>
							{rating}
						</article>
						<article className="px-20 lg:px-32 max-lg:px-8 max-md:px-3">
							<div className="flex flex-row justify-items-center items-baseline">
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar5} alt="Avatar Kate J." />
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar1} alt="Avatar Jacob B." />
								<img className="mx-auto flex-none h-18 w-18 md:h-24 md:w-24" src={avatar2} alt="Avatar Diana G." />
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar3} alt="Avatar Mia S." />
								<img className="mx-auto flex-none h-10 w-10 md:h-16 md:w-16 opacity-20" src={avatar4} alt="Avatar Natalie R." />
							</div>
							<h3 className="my-5 text-lg font-semibold">Diana G.</h3>
							<p className="my-5">The ease of use and the effectiveness of this service are unmatched. I've seen a real increase in engagement on all my posts, making my social media strategy more successful than ever!</p>
							{rating}
						</article>
					</Slider>
				</div>
				<div className="testimonials-triangle-bottomLeft absolute align-bottom"></div>
			</section>
		</>
	)
}
